import React from 'react'

export const Backend = () => {
  return (
    <div className="skills__content">
        <h3 className="skills__title">Backend and Other</h3>
        <div className="skills__box">
            <div className="skills__group">
                <div className="skills__data">
                    <i className="bx bx-badge-check"></i>
               

                <div className="">
                    <h3 className="skills__name">MySql</h3>
                    <span className="skills__level">Advance</span>
                </div>
                </div>
                <div className="skills__data">
                    <i className="bx bx-badge-check"></i>
               

                <div className="">
                    <h3 className="skills__name">Java</h3>
                    <span className="skills__level">Advance</span>
                </div>
                </div>
                <div className="skills__data">
                    <i className="bx bx-badge-check"></i>
               

                <div className="">
                    <h3 className="skills__name">NodeJs</h3>
                    <span className="skills__level">Basic</span>
                </div>
                </div>
            </div>
            <div className="skills__group">
                <div className="skills__data">
                    <i className="bx bx-badge-check"></i>
               

                <div className="">
                    <h3 className="skills__name">C++</h3>
                    <span className="skills__level">Intermediate</span>
                </div>
                </div>
                <div className="skills__data">
                    <i className="bx bx-badge-check"></i>
               

                <div className="">
                    <h3 className="skills__name">Mongodb</h3>
                    <span className="skills__level">Basic</span>
                </div>
                </div>
                <div className="skills__data">
                    <i className="bx bx-badge-check"></i>
               

                <div className="">
                    <h3 className="skills__name">Spring Boot</h3>
                    <span className="skills__level">Intermediate</span>
                </div>
                </div>
                <div className="skills__data">
                    <i className="bx bx-badge-check"></i>
               

                <div className="">
                    <h3 className="skills__name">Hibernate</h3>
                    <span className="skills__level">Intermediate</span>
                </div>
                </div>
                <div className="skills__data">
                    <i className="bx bx-badge-check"></i>
               

                <div className="">
                    <h3 className="skills__name">Sql</h3>
                    <span className="skills__level">Advance</span>
                </div>
                </div>
            </div>
        </div>
    </div>
  )
}
